import css from 'styled-jsx/css';

const styles = css.global`#partiu-gp-como-participar {
  padding: 48px 0 56px;
  background: #fff;
  overflow: hidden;
}

#partiu-gp-como-participar .titulo {
  margin: 0 0 8px;
  color: #222;
  font-family: 'SantanderHeadline';
  font-size: 28px;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
}

#partiu-gp-como-participar .subtitulo {
  margin: 0 0 24px;
  color: #222;
  font-family: 'SantanderHeadline';
  font-size: 20px;
  font-weight: 800;
  line-height: 26px;
  text-align: center;
}

#partiu-gp-como-participar .card {
  background: #f6f6f6;
  border-radius: 24px;
  padding: 24px;
  width: 260px;
  flex: 0 0 260px;
  min-height: 190px;
  margin-right: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

#partiu-gp-como-participar .card-titulo {
  margin: 0 0 8px;
  color: #222;
  font-family: 'SantanderMicroText';
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
}

#partiu-gp-como-participar .card-texto {
  margin: 0;
  color: #444;
  font-family: 'SantanderMicroText';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

#partiu-gp-como-participar .cta {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: fit-content;
  margin: 24px auto 0;
  padding: 0 32px;
  border-radius: 999px;
  background: #ec0000;
  color: #fff;
  font-family: 'SantanderText';
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 350ms linear;
}

#partiu-gp-como-participar .cta:hover {
  background-color: #f14c4c;
}

@media (min-width: 992px) {
  #partiu-gp-como-participar .titulo {
    font-size: 32px;
    line-height: 38px;
  }

  #partiu-gp-como-participar .subtitulo {
    margin: 0 0 44px;
    font-size: 54px;
    line-height: 62px;
    margin-left: auto;
    margin-right: auto;
  }

  #partiu-gp-como-participar .cards {
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 24px;
  }

  #partiu-gp-como-participar .cards .card {
    flex: 0 0 212px;
    width: 212px;
    min-width: 0;
    margin-right: 0;
  }
}
`;

export default styles;